module.exports = __webpack_public_path__ + "resources/img/main03_jp_m.bea6ccb4ddcd6d613688ce038f668707.png";